import React from "react";

export default function MySQL_YEAR() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_YEAR</h1>
      <p>This is the MySQL_YEAR component generated from the SQL JSON.</p>
    </div>
  );
}
